<template>
  <div class="card modal-card w-full">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content mgl-0 pd-40px">
        <div class="columns is-gapless is-multiline">
          <div class="column is-10">
            <h1 class="title is-size-3">
              {{ duplicateView ?
              $t('detailDevis.popupDuplicate.title', { reseau: ligneSelect.produit.libelle })
              : $t(getTitle, { reseau: ligneSelect.produit.reference })}}
            </h1>
            <p class="has-text-icon-more">
              {{ $t('detailDevis.popupDuplicate.nbFace', { nbFace: nbFaceTotal }) }}
            </p>
            <p class="has-text-icon-more">
              {{ getDateReseau }}
            </p>
          </div>
          <div class="column is-2 has-text-right has-text-icon-more">
              {{ $t('ajoutDevis.popUpSelectFace.nbFacesDispo',
            { totalSelect: getTotalSelectedFace,
              total: nbFaceTotal })}}
          </div>
          <div class="column is-12 mgt-20px has-text-warning has-text-weight-bold"
               v-if="getNombreFaceIndispoInLogistique > 0">
            {{ $t('ajoutDevis.popUpSelectFace.faceIndispoLogistique') }}
          </div>
        </div>
        <div
          v-if="showListFacesUnavailable && getListMessageFacesUnavailable.length"
          class="mgb-20px">
          <app-information-msg-component
            :title="$t('ajoutDevis.popUpSelectFace.faceIndispoOptionBlocage')"
            :libelleList="getListMessageFacesUnavailable"
            :canClose="false"/>
        </div>
        <qd-message
          type="is-info"
          v-if="duplicateView">
          {{ $t('ajoutDevis.popUpDuplicationLigne.warningSelection') }}
        </qd-message>
        <tab-select-faces
          v-if="mountedLoadingEnd && !duplicateView"
          :liste-faces-base="listeFacesBase"
          :ligne-select="ligneSelect"
          :displayColumnLogistique="displayColumnLogistique"
          :isDetail="isDetail"
          :inAffectation="inAffectation"
          :permissions="permissions"
          @handleDuplicateView="handleDuplicateView"
          :duplicateView="duplicateView"/>
        <tab-duplicate-faces
          v-if="mountedLoadingEnd && duplicateView"
          :listeLignes="getLignesForDuplicate"
          :ligneSelect="ligneSelect"
          :typeDcf="typeDcf"
          @duplicate="duplicate"/>
        <footer class="mgt-20px mgl-0">
          <b-field class="mgl-0">
            <div class="is-pulled-left boutonAction">
              <a class="button is-cancel btn-modal-annuler mgb-40px"
                 @click="duplicateView ? duplicateView = !duplicateView : $parent.close()">
                {{ $t(getTitleBoutonBack) }}
              </a>
            </div>
            <div class="is-pulled-left boutonAction mgl-0"
                 v-if="!isDetail">
              <button class="button is-addOrEdit" @click="duplicateView ? duplicate() : selection()"
                 :disabled="duplicateView && nbDuplicateLigneSelected.length < 1">
                {{ duplicateView
                ? $t('general.button.dupliquer')
                : $t('ajoutDevis.popUpSelectFace.actions.select') }}
              </button>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getLignesSelectionFace } from '@/services/dcf/reseauTempo/getListeFacesForSelection';
import messageErreur from '@/services/general/messageErreur';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import tabSelectFaces from '@/components/devisCommandeFacture/facesSelectInReseauTempo/tabSelectFaces';
import formatDate from '@/services/general/formatDate';
import {
  BLOQUE, OPTION,
  LIGNE_CMD_SEL_TYPE_SEMAINE,
  LIGNE_CMD_SEL_TYPE_PERIODE,
  BLOQUE_COMMANDE,
} from '@/configuration/optionBlocage/optionBlocage';
import {
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_MAIRIE,
} from '@/configuration/catalogue/produitConf';
import { TYPE_DEVIS, TYPE_COMMANDE, TYPE_FACTURE } from '@/configuration/devisConf';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import TabDuplicateFaces
  from '@/components/devisCommandeFacture/facesSelectInReseauTempo/tabDuplicateFaces';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ligneSelect: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: true,
    },
    displayColumnLogistique: {
      type: Boolean,
      required: true,
    },
    inAffectation: {
      type: Boolean,
      required: false,
      default: false,
    },
    permissions: {
      type: Object,
      required: true,
    },
    devisCommande: {
      type: Object,
      required: false,
    },
    typeDcf: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      listeFacesBase: [],
      mountedLoadingEnd: false,
      duplicateView: false,
      authorizedTypes: [
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_MAIRIE,
        CATEGORIE_REGROUPEMENT_LC,
      ],
      authorizedEtat: [BLOQUE, OPTION],
    };
  },
  components: {
    TabDuplicateFaces,
    AppInformationMsgComponent,
    tabSelectFaces,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    isSelectedForReseauTempo() {
      return this.ligneSelect.typeProduit === CATEGORIE_REGROUPEMENT;
    },
    isSelectedForReseauMairie() {
      return this.ligneSelect.typeProduit === CATEGORIE_REGROUPEMENT_MAIRIE;
    },
    isSelectedForReseauLc() {
      return this.ligneSelect.typeProduit === CATEGORIE_REGROUPEMENT_LC;
    },
    getNombreFaceIndispoInLogistique() {
      return this.listeFacesBase.filter((face) => {
        return !face.dispo && face.selected;
      }).length;
    },
    getDateReseau() {
      let dateTrad = 'datePeriode';
      if (this.isSelectedForReseauTempo) dateTrad = 'dateSemaine';
      if (this.isSelectedForReseauMairie) dateTrad = 'dateJour';
      return this.$i18n.t(`detailDevis.popUpSelectFace.${dateTrad}`, {
        semaine: this.ligneSelect.ligneReseau.anneeSemaine?.toString().substring(4, 6),
        dateDebut: formatDate(this.ligneSelect.dateDebut),
        dateFin: formatDate(this.ligneSelect.dateFin),
      });
    },
    getTotalSelectedFace() {
      return this.listeFacesBase.filter(face => { return face.selected; }).length;
    },
    getTitle() {
      return this.isDetail ? 'detailDevis.popUpSelectFace.title' : 'ajoutDevis.popUpSelectFace.title';
    },
    getTitleBoutonBack() {
      return this.isDetail ? 'detailDevis.popUpSelectFace.actions.back' : 'ajoutDevis.popUpSelectFace.actions.cancel';
    },
    showListFacesUnavailable() {
      return !this.isDetail && this.ligneSelect.etatSouhaite === BLOQUE
        && this.ligneSelect.lignesCmdSelOptionProduit?.length;
    },
    getListMessageFacesUnavailable() {
      if (!this.mountedLoadingEnd || !this.showListFacesUnavailable) return [];
      const lignesOption = this.ligneSelect.lignesCmdSelOptionProduit;
      const lignesBlocage = this.ligneSelect.ligneReseau.lignesCmdSelProduits;
      return lignesOption
        .filter(o => !lignesBlocage.some((b) => b.produitId === o.produitId))
        .map(l => {
          const face = this.listeFacesBase.find(f => f.produitId === l.produitId);
          return { isLink: false, libelle: face.libelle };
        });
    },
    getLignesForDuplicate() {
      const ligneSelectProduitId = this.ligneSelect.produitId;
      const ligneSelectOrdre = this.ligneSelect.ordre;
      return this.devisCommande.lignesCommande.filter(l => l.produitId === ligneSelectProduitId
        && l.ordre !== ligneSelectOrdre
        && l.etatObtenu !== BLOQUE_COMMANDE
        && this.authorizedTypes.includes(l.typeProduit)
        && (this.typeDcf !== TYPE_DEVIS || this.authorizedEtat.includes(l.etatSouhaite)));
    },
    nbDuplicateLigneSelected() {
      return this.getLignesForDuplicate
        .filter((ligne) => { return ligne.select; });
    },
    nbFaceTotal() {
      return this.listeFacesBase.length;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    selection(noClose) {
      this.update(this.ligneSelect);
      if (!noClose) {
        this.$parent.close();
      }
    },
    duplicate() {
      this.nbDuplicateLigneSelected.forEach((ligne) => {
        this.update(ligne);
      });
      this.$parent.close();
    },
    update(ligne) {
      const facesSelected = this.listeFacesBase.filter(face => face.selected);
      const anneeSemaine = ligne.ligneReseau.anneeSemaine;
      const dateDebut = ligne.dateDebut;
      let dateFin = ligne.dateFin;
      if (ligne.typeProduit === CATEGORIE_REGROUPEMENT_MAIRIE) {
        dateFin = ligne.dateDebut;
      }
      const mapForBlocage = (face) => ({
        produitId: face.produitId,
        anneeSemaine: anneeSemaine || getAnneeSemaineFromDate(dateDebut),
        reference: face.reference,
        instructionPose: face.instructionPose,
        dateDebut: this.isSelectedForReseauTempo ? null : dateDebut,
        dateFin: this.isSelectedForReseauTempo ? null : dateFin
          || dateDebut,
        type: this.isSelectedForReseauTempo
          ? LIGNE_CMD_SEL_TYPE_SEMAINE
          : LIGNE_CMD_SEL_TYPE_PERIODE,
      });
      const mapForOption = (face) => ({
        produitId: face.produitId,
        anneeSemaine: anneeSemaine || getAnneeSemaineFromDate(dateDebut),
        ligneCommandeId: this.ligneSelect.id,
        dateDebut: this.isSelectedForReseauTempo ? null : dateDebut,
        dateFin: this.isSelectedForReseauTempo ? null : dateFin,
        type: this.isSelectedForReseauTempo
          ? LIGNE_CMD_SEL_TYPE_SEMAINE
          : LIGNE_CMD_SEL_TYPE_PERIODE,
      });
      if ([TYPE_COMMANDE, TYPE_FACTURE].includes(this.typeDcf)
        || ligne.etatSouhaite === BLOQUE
        || ligne.etatObtenu === BLOQUE) {
        this.$emit('updateLignesCmdSelProduits', facesSelected.map(mapForBlocage), ligne);
      }
      if (this.estSelectionEnOption(ligne)) {
        this.$emit('updateLignesCmdSelOptionProduits', facesSelected.map(mapForOption), ligne);
      }
      this.$emit('updateTlpe', ligne);
    },
    handleDuplicateView() {
      this.selection(true);
      this.duplicateView = true;
    },
    estSelectionEnOption(ligne) {
      return this.typeDcf === TYPE_DEVIS
        && ligne.etatSouhaite === OPTION
        && ligne.etatObtenu !== BLOQUE;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    const isDetail = this.isDetail && !this.inAffectation;
    try {
      await this.loadParametreUtilisateur();
      const users = this.parametre(PARAMETRES_KEYS.utilisateur);
      const liste = await getLignesSelectionFace(this.ligneSelect,
        this.estSelectionEnOption(this.ligneSelect), users, this.societeActiveId, isDetail);
      liste.sort((a, b) => a.affecteLogistiquement - b.affecteLogistiquement);
      this.listeFacesBase = liste;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    } finally {
      this.mountedLoadingEnd = true;
    }
  },
};
</script>
